export default __webpack_public_path__ + "static/media/photo_right_3.828bf505.png";